"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  templates: [{
    name: 'urban',
    displayName: 'Urban',
    image: 'urban_tumb_v4.jpg',
    fullImage: 'urban_template.jpg'
  }, {
    name: 'business',
    displayName: 'Professional',
    image: 'professional_tumb_v4.jpg',
    fullImage: 'professional_template.jpg'
  }, {
    name: 'trade',
    displayName: 'Trade',
    image: 'trade_tumb_v4.jpg',
    fullImage: 'trade_template.jpg'
  }, {
    name: 'global',
    displayName: 'Global',
    image: 'global_tumb_v4.jpg',
    fullImage: 'global_template.jpg'
  }, {
    name: 'insider',
    displayName: 'Insider',
    image: 'insider_tumb_v4.jpg',
    fullImage: 'insider_template.jpg',
    hidden: true
  }, {
    name: 'sleek',
    displayName: 'Sleek',
    image: 'sleek_tumb_v4.jpg',
    fullImage: 'sleek_template.jpg'
  }, {
    name: 'classic',
    displayName: 'Classic',
    image: 'classic_tumb_v4.jpg',
    fullImage: 'classic_template.jpg'
  }],
  colorKeys: ['color0', 'color1', 'color2', 'color3', 'color4', 'color5'],
  colors: [{
    name: 'Orange Sunrise',
    description: 'Bright and dynamic',
    default: 'business',
    colors: {
      color0: '#ef6f7f',
      color1: '#fc8b62',
      color2: '#000000',
      color3: '#636363',
      color4: '#ffffff',
      color5: '#ffffff'
    }
  }, {
    name: 'Violet Blue',
    description: 'Deep and bold',
    default: 'business',
    colors: {
      color0: '#46559A',
      color1: '#46559A',
      color2: '#000000',
      color3: '#636363',
      color4: '#EEEEEE',
      color5: '#ffffff'
    }
  }, {
    name: 'Lime Green',
    description: 'Vibrant and refreshing',
    default: 'sleek',
    colors: {
      color0: '#3CB878',
      color1: '#3CB878',
      color2: '#000000',
      color3: '#636363',
      color4: '#E1E2E7',
      color5: '#ffffff'
    }
  }, {
    name: 'Deep Ocean',
    description: 'Bold and deep',
    default: 'classic',
    colors: {
      color0: '#303F51',
      color1: '#303F51',
      color2: '#000000',
      color3: '#636363',
      color4: '#E1E2E7',
      color5: '#ffffff'
    }
  }, {
    name: 'Rocky Nature',
    description: 'Warm and balanced',
    default: 'urban',
    colors: {
      color0: '#e85664',
      color1: '#e85664',
      color2: '#bababa',
      color3: '#4d4843',
      color4: '#ffffff',
      color5: '#efefef'
    }
  }, {
    name: 'Bee Hive',
    description: 'Bold and deep',
    default: 'trade',
    colors: {
      color0: '#fed136',
      color1: '#fed136',
      color2: '#121212',
      color3: '#b0b0b0',
      color4: '#f2f2f2',
      color5: '#ffffff'
    }
  }, {
    name: 'Rude Mood',
    description: 'Energetic and dynamic',
    default: 'global',
    colors: {
      color0: '#f66da8',
      color1: '#f66da8',
      color2: '#074a80',
      color3: '#252222',
      color4: '#eeeeee',
      color5: '#ffffff'
    }
  }, {
    name: 'Paper Flyer',
    description: 'Fresh and bright',
    default: 'insider',
    colors: {
      color0: '#4184cb',
      color1: '#4184cb',
      color2: '#1a1a1a',
      color3: '#636363',
      color4: '#ffffff',
      color5: '#ebebeb'
    }
  }, {
    name: 'Yellow Orange ',
    description: 'Vibrant and playful',
    colors: {
      color0: '#DD8300',
      color1: '#DD8300',
      color2: '#35527C',
      color3: '#636363',
      color4: '#E2EFEE',
      color5: '#ffffff'
    }
  }, {
    name: 'Sunset',
    description: 'Soft and muted',
    colors: {
      color0: '#2F3E51',
      color1: '#2F3E51',
      color2: '#DF4F37',
      color3: '#636363',
      color4: '#4C96DF',
      color5: '#ECF0F1'
    }
  }, {
    name: 'Shallow Water',
    description: 'Moody and deep',
    colors: {
      color0: '#1C1D21',
      color1: '#1C1D21',
      color2: '#31353E',
      color3: '#636363',
      color4: '#9ACDD0',
      color5: '#EFEFF7'
    }
  }, {
    name: 'Sea Wolf',
    description: 'Moody and deep',
    colors: {
      color0: '#CD3D0E',
      color1: '#CD3D0E',
      color2: '#2A2C2B',
      color3: '#636363',
      color4: '#D7D7D7',
      color5: '#EBEBEB'
    }
  }, {
    name: 'Times Changing',
    description: 'Moody and deep',
    colors: {
      color0: '#332533',
      color1: '#332533',
      color2: '#634D53',
      color3: '#636363',
      color4: '#F5E3CF',
      color5: '#F6EDE4'
    }
  }, {
    name: 'Butterscotch',
    description: 'Moody and deep',
    colors: {
      color0: '#F65600',
      color1: '#F65600',
      color2: '#2D3A43',
      color3: '#636363',
      color4: '#C2D4E0',
      color5: '#EFEFEF'
    }
  }, {
    name: 'Red Curry',
    description: 'Moody and deep',
    colors: {
      color0: '#5B1628',
      color1: '#5B1628',
      color2: '#1F2327',
      color3: '#636363',
      color4: '#D4D1CC',
      color5: '#F7F2F3'
    }
  }, {
    name: 'Violet',
    description: 'Cool and vibrant',
    colors: {
      color0: '#44A0A8',
      color1: '#44A0A8',
      color2: '#2F2934',
      color3: '#636363',
      color4: '#2F2934',
      color5: '#EEF2E8'
    }
  }, {
    name: 'Fresh Grass',
    description: 'Energetic green',
    colors: {
      color0: '#55C038',
      color1: '#55C038',
      color2: '#08261A',
      color3: '#636363',
      color4: '#55C038',
      color5: '#E7F2E2'
    }
  }, {
    name: 'Fuchsia',
    description: 'Striking and bold',
    colors: {
      color0: '#BF4850',
      color1: '#BF4850',
      color2: '#6D324A',
      color3: '#636363',
      color4: '#DFB294',
      color5: '#ECE7E5'
    }
  }, {
    name: 'Nautical',
    description: 'Classic and timeless',
    colors: {
      color0: '#2F3E51',
      color1: '#2F3E51',
      color2: '#F34745',
      color3: '#636363',
      color4: '#D6DADB',
      color5: '#FFFFFF'
    }
  }, {
    name: 'Blue Sky',
    description: 'Classic and timeless',
    colors: {
      color0: '#1C1F2C',
      color1: '#1C1F2C',
      color2: '#373760',
      color3: '#636363',
      color4: '#90A3CF',
      color5: '#EBF0F6'
    }
  }, {
    name: 'Sparkling Purple',
    description: 'Classic and timeless',
    colors: {
      color0: '#290051',
      color1: '#290051',
      color2: '#391264',
      color3: '#636363',
      color4: '#D6CCE2',
      color5: '#E8E1EF'
    }
  }, {
    name: 'Pink Peppermint',
    description: 'Classic and timeless',
    colors: {
      color0: '#B01B35',
      color1: '#B01B35',
      color2: '#B01B35',
      color3: '#636363',
      color4: '#E9BFC6',
      color5: '#F3ECEE'
    }
  }, {
    name: 'Sparkling Sife',
    description: 'Classic and timeless',
    colors: {
      color0: '#610C4B',
      color1: '#610C4B',
      color2: '#301434',
      color3: '#636363',
      color4: '#C7D6E9',
      color5: '#F3ECEE'
    }
  }, {
    name: 'Aqua',
    description: 'Classic and timeless',
    colors: {
      color0: '#122E5D',
      color1: '#122E5D',
      color2: '#1F4391',
      color3: '#636363',
      color4: '#5691DD',
      color5: '#86BAF6'
    }
  }],
  images: ['https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-8415_o8eimt', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/Stocksy_txp1a13f50bVZF000_Large_366157_lyujnt', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire_IMG_5326_cduclb', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-8937_hfmyvs', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-7151_w5fx9u', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-7662_eqi7sf', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-4229_vpccb2', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-7907_pi0ik7', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-7066_xgumhj', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-0369_qbo6ca', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/114H_qdn6dt', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-0447_iruytl', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire-0245_d2icfh', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/158H_ciy0ob', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/SplitShire_5678_mvnuyi', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/21H_pangyj', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/113H_oza488', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/25H_v9vbhh', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/110H_tnz0mm', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/43H_mxt0j0', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/44HH_iyzolb', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/8H_k5nxgm', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/56H_ffaz4k', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/39H_j9x7mn', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/33H_pvav2o', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/34H_wy5dcf', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/17H_ttadwe', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/stage_ev86h6', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/reception_kpbm5m', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/listen_jolane', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/airport_kjf5ub', 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1419411425/abstract_koheud'],
  sectionsDisplayNames: {
    header: 'Header',
    description: 'Event Description',
    tickets: 'Registrations',
    buttons: 'Custom Buttons',
    attendees: 'Community',
    sponsors: 'Sponsors',
    exhibitors: 'Exhibitors',
    eventVenue: 'Map',
    downloadApp: 'Download App',
    speakers: 'Speakers',
    people: 'Contacts',
    html: 'Custom Element',
    form: 'Form',
    iframe: 'Code Element',
    countdownClock: 'Countdown',
    multiElement: 'Custom Element',
    customElementGroups: 'Custom Element'
  }
};
exports.default = _default;